import React from 'react';
import PartnerListContainer from '../../containers/partnermng/PartnerListContainer';
const PartnerListPage = () => {
  return (
    <PartnerListContainer />
  );
};

export default PartnerListPage;
